import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeInUp } from '../../lib/animations';

export function CtaSection({ isAuthenticated, browseArtistsLink }) {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={fadeInUp.initial}
          whileInView={fadeInUp.animate}
          viewport={{ once: true }}
          className="relative p-12 sm:p-16 rounded-3xl overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(112, 0, 255, 0.2) 0%, rgba(212, 255, 0, 0.1) 100%)',
          }}
        >
          <div className="relative z-10 max-w-2xl">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-4">
              Ready to Get Your Exclusive Dubplate?
            </h2>
            <p className="text-lg text-[#A1A1AA] mb-8">
              Join thousands of DJs, sound systems, and music lovers who trust Tune4Tune for authentic custom dubplates.
            </p>
            {isAuthenticated ? (
              <Link to={browseArtistsLink} className="btn-primary inline-flex items-center gap-2" data-testid="cta-browse-btn">
                Browse Artists
                <ArrowRight className="w-4 h-4" />
              </Link>
            ) : (
              <Link to="/register" className="btn-primary inline-flex items-center gap-2" data-testid="cta-signup-btn">
                Create Account
                <ArrowRight className="w-4 h-4" />
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
